import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'
import css from './CarDeleteModal.module.css'
import { AppContext } from '../../../../providers/appProvider';
import Remove from "../../../../assets/Icon/Remove";
import { useTranslation } from 'react-i18next';
 

const CarDeleteModal = ({ carService, defaultCar, isBtn }) => {
    const {t} = useTranslation();
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);

    const confirmDelete = () => { 
        carService.deleteCar(defaultCar.id)
            .then((response) => {
            })
            .catch((error) => {
                app.setError("შეცდომა წაშლისას")
            });
    };

    const openDelete = () => {
        setIsModalOpen(true)
    }

    const closeDelete = () => {
        setIsModalOpen(false)
    }

    return (
        <>
            <span className={ css.removeBtn } onClick={() => openDelete()} >
               <Remove/> {t('Delete')}
            </span>

            <Modal key={defaultCar.id} size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>

                <div className={css.modalHead } >
                    <h3>
                        <span className={ css.iconHead } > <Remove/></span>
                        {t('Delete')}
                    </h3>
                </div>

                <div className={ css.message } >{t('ConfirmDelete')}</div>

                <div className={ css.buttons }>
                    <button className={ css.removeBtnYes } onClick={confirmDelete}>{t('YesIdo')}</button> 
                </div>

            </Modal>
        </>
    );
};

export default CarDeleteModal;